import React, { useState } from 'react';
import Button from 'components/atoms/Button';
import { getCookie } from 'helpers/common';

export default function DownloadStatementsProgress({
  mids = [],
  year = new Date().getMonth() === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear(),
  month = new Date().getMonth() === 0 ? 12 : new Date().getMonth(),
}) {
  const [progress, setProgress] = useState({ done: 0, total: 0, message: '', link: '', error: '' });
  const [started, setStarted] = useState(false);

  const handleDownload = async () => {
    setStarted(true);
    setProgress({ done: 0, total: 0, message: '', link: '', error: '' });
    try {
      // eslint-disable-next-line eqeqeq
      if (month == '12') {
        // eslint-disable-next-line no-param-reassign
        year += 1;
      }

      const res = await fetch(`${process.env.REACT_APP_COMMON_API_URL}/merchant-tool/download-statements`, {
        method: 'POST',
        body: JSON.stringify({ mids, year, month }),
        headers: {
          Authorization: `Bearer ${getCookie(process.env.REACT_APP_PSP_TOKEN_COOKIE)}`,
          'Content-Type': 'application/json',
          Accept: 'text/event-stream',
        },
      });
      if (!res.body) throw new Error('No response body');
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        if (value) {
          buffer += decoder.decode(value, { stream: true });
          const parts = buffer.split(/\n\n/);
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < parts.length - 1; i++) {
            const part = parts[i];
            if (part.startsWith('data:')) {
              try {
                const data = JSON.parse(part.replace(/^data:/, '').trim());
                if (data.error) {
                  setProgress(prev => ({ ...prev, error: data.error }));
                  return;
                }
                setProgress(prev => ({ ...prev, ...data }));
                if (data.link) return;
              } catch {
                setProgress(prev => ({ ...prev, error: 'Invalid server response' }));
                return;
              }
            }
          }
          buffer = parts[parts.length - 1];
        }
      }
    } catch (err) {
      setProgress(prev => ({ ...prev, error: err.message || 'Unknown error' }));
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '40vh',
        background: 'rgba(0,0,0,0.05)',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        padding: 32,
        maxWidth: 400,
        margin: '40px auto',
        flexDirection: 'column',
      }}>
      {!started ? (
        <div style={{ textAlign: 'center' }}>
          <h3 style={{ marginBottom: 16 }}>Download Statements</h3>
          <Button
            type="primary"
            onClick={handleDownload}
            disabled={!mids.length || !year || !month}
            style={{ width: '100%', padding: '12px 0', fontSize: 16 }}>
            Generate Download Link
          </Button>
        </div>
      ) : progress.error ? (
        <div style={{ color: 'red', textAlign: 'center' }}>
          <h4>Error</h4>
          <div>{progress.error}</div>
          <Button
            type="default"
            onClick={() => {
              setStarted(false);
              setProgress({ done: 0, total: 0, message: '', link: '', error: '' });
            }}
            style={{ marginTop: 16 }}>
            Try Again
          </Button>
        </div>
      ) : progress.link ? (
        <div style={{ textAlign: 'center' }}>
          <h4>Ready!</h4>
          <a
            href={progress.link}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              margin: '16px 0',
              padding: '12px 24px',
              background: '#1890ff',
              color: '#fff',
              borderRadius: 6,
              textDecoration: 'none',
              fontWeight: 500,
              fontSize: 16,
            }}>
            Download Statements ZIP
          </a>
          <Button
            type="default"
            onClick={() => {
              setStarted(false);
              setProgress({ done: 0, total: 0, message: '', link: '', error: '' });
            }}
            style={{ marginTop: 8 }}>
            New Download
          </Button>
        </div>
      ) : (
        <div style={{ width: '100%', textAlign: 'center' }}>
          <h4 style={{ marginBottom: 8 }}>Processing Statements</h4>
          <div style={{ marginBottom: 12, color: '#555' }}>{progress.message || 'Processing...'}</div>
          <div style={{ marginBottom: 16 }}>
            <span style={{ fontWeight: 500 }}>{progress.done}</span>
            <span style={{ color: '#888' }}> / {progress.total || '...'}</span>
          </div>
          <div
            style={{
              width: '100%',
              height: 12,
              background: '#eee',
              borderRadius: 6,
              overflow: 'hidden',
              marginBottom: 8,
            }}>
            <div
              style={{
                width: progress.total ? `${Math.round((progress.done / progress.total) * 100)}%` : '0%',
                height: '100%',
                background: '#1890ff',
                transition: 'width 0.3s',
              }}
            />
          </div>
          <div style={{ fontSize: 12, color: '#aaa' }}>Please wait, this may take a moment...</div>
        </div>
      )}
    </div>
  );
}
